import { Box } from "../../box";
import { forwardRef, useEffect, useState } from "react";
import { isNilOrEmpty, mergeProps, useEventCallback, useIsInitialRender } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerTransition({
  animateFirstRender = false,
  as = DefaultElement,
  children,
  enter,
  forwardedRef,
  leave,
  show,
  ...rest
}) {
  const [isVisible, setIsVisible] = useState(show);
  const isInitialRender = useIsInitialRender();
  useEffect(() => {
    if (show) {
      setIsVisible(true);
    } else if (isNilOrEmpty(leave)) {
      setIsVisible(false);
    }
  }, [show, leave]);
  const handleAnimationEnd = useEventCallback(() => {
    setIsVisible(show);
  }); // @ts-ignore

  const isAnimationDisabled = Transition.disableAnimation;
  const shouldRender = isAnimationDisabled ? show : isVisible;

  if (!shouldRender) {
    return null;
  }

  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: show ? isInitialRender ? animateFirstRender ? enter : undefined : enter : leave,
      onAnimationEnd: !isAnimationDisabled ? handleAnimationEnd : undefined,
      ref: forwardedRef
    }),
    children: children
  });
}
InnerTransition.defaultElement = DefaultElement;
export const Transition = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTransition, { ...props,
  forwardedRef: ref
}));
// Jest tests requires to disable the animation because "onAnimationEnd" is never fired. I can't figure out why.
// @ts-ignore
Transition.disableAnimation = false;